import * as React from 'react';
import ExpendituresCore from '../AfrCore/ExpendituresCore';

const Expenditures = (props: any) => {

    return (
        <React.Fragment>
            <ExpendituresCore userRole="ENTITY_USER" />
        </React.Fragment>
    );
}

export default Expenditures;